import { queryClient } from "src/lib/react-query";
import { driverRoadTestQueryOptions } from "src/api/mvte/driver-road-test-query-options";
import { useState } from "react";
import { FaFileDownload } from "react-icons/fa";
import clsx from "clsx";

function DownloadCertificateButton({
    certificateName,
}: {
    certificateName: string;
}) {
    const [isFetching, setIsFetching] = useState(false);

    async function handleDownloadCertificate() {
        setIsFetching(true);
        const certificateBase64 = await queryClient.fetchQuery(
            driverRoadTestQueryOptions.certificateQueryOptions({
                params: { certificateName },
            }),
        );
        setIsFetching(false);

        const linkElement = document.createElement("a");
        linkElement.href = `data:application/pdf;base64,${certificateBase64}`;
        linkElement.download = certificateName;
        linkElement.click();
    }

    return (
        <button
            onClick={handleDownloadCertificate}
            className={clsx(
                "btn btn-accent btn-sm",
                isFetching && "pointer-events-none opacity-50",
            )}
        >
            {isFetching ? (
                <>
                    <span className="loading loading-spinner loading-xs" />
                    Downloading
                </>
            ) : (
                <>
                    <FaFileDownload />
                    Certificate
                </>
            )}
        </button>
    );
}

export { DownloadCertificateButton };
